import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from '@mui/material';
import React, { useEffect } from 'react';

export default function UnitTrustDialog(props) {
    useEffect(() => {
        console.log(props.fee);
    }, []);
    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>Unit Trust</DialogTitle>
            <DialogContent>
                <DialogContentText>Fill in the form to add/edit the unit trust</DialogContentText>
                <Grid style={{ marginTop: '10px' }} container spacing={2}>
                    <Grid item xs={6}>
                        <TextField
                            value={props.code}
                            onChange={(e) => props.setCode(e.target.value)}
                            margin="dense"
                            id="code"
                            label="Code"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            value={props.name}
                            onChange={(e) => props.setName(e.target.value)}
                            margin="dense"
                            id="name"
                            label="Unit Trust Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/* <TextField margin="dense" id="client" label="Client" type="text" fullWidth variant="outlined" /> */}
                        <FormControl fullWidth disabled={props.disableClient ? props.disableClient : false}>
                            <InputLabel id="demo-simple-select-label">Client</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={props.client}
                                label="Client"
                                onChange={(e) => props.setClient(e.target.value)}
                            >
                                {props.clientsRes.map((item) => {
                                    return (
                                        <MenuItem key={`client-${item.code}`} value={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>
                            }}
                            inputProps={{ min: 0, style: { textAlign: 'right' } }}
                            value={props.fee}
                            onChange={(e) => props.setFee(e.target.value)}
                            margin="dense"
                            id="fee"
                            label="Fee"
                            type="text"
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Cancel</Button>
                <Button onClick={props.handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
}
